module.exports = __webpack_public_path__ + "media/svg/arrow-down-thin-34dc37eb.svg";